<template>
    <c-title :name="$router.getTitle()" root :routeItem="$router.getRouteItem()" @back="back" :history="history" @rootClick="rootClick"/>
</template>
<script>
export default {
    name: 'ScpmTitle',
    props:['history'],
    methods:{
        rootClick(){
            this.$router.replace('/');
        },
        back(){
          //console.log("backbackbackbackbackback")
            this.$emit("back");
        }
    }
};
</script>
<style scoped>
    .c-title.c-title-root{
        border: none;
        padding: 0;
        align-items: center;
    }
</style>